import React from 'react';
import type { CompanyNotificationSettings } from '../types';

interface CompanyNotificationCardProps {
  settings: CompanyNotificationSettings;
  onUpdate: (settings: CompanyNotificationSettings) => Promise<void>;
  loading: boolean;
}

const NOTIFICATION_OPTIONS = [
  {
    id: 'newCandidateApplications',
    title: 'New Candidate Applications',
    description: 'Notify me when a candidate applies to a job posting.',
  },
  {
    id: 'jobPostExpirationAlerts',
    title: 'Job Post Expiration Alerts',
    description: 'Notify me when a job posting is about to expire.',
  },
  {
    id: 'systemAnnouncements',
    title: 'System Announcements',
    description: 'Receive important platform updates and announcements.',
  },
] as const;

const CompanyNotificationCard: React.FC<CompanyNotificationCardProps> = ({
  settings,
  onUpdate,
  loading,
}) => {
  const handleToggle = async (key: keyof CompanyNotificationSettings) => {
    await onUpdate({
      ...settings,
      [key]: !settings[key],
    });
  };

  return (
    <div className="bg-white rounded-2xl p-6 border border-[#EDEDED]">
      <div className="mb-6">
        <h2
          style={{
            fontFamily: 'Manrope',
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: '27px',
            color: '#0B111E',
          }}
        >
          Notification Settings
        </h2>
        <p
          style={{
            fontFamily: 'Manrope',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '19px',
            color: '#757575',
            marginTop: '4px',
          }}
        >
          Choose what notifications you want to receive
        </p>
      </div>

      <div className="space-y-4">
        {NOTIFICATION_OPTIONS.map((option) => (
          <div
            key={option.id}
            className="flex items-center justify-between py-3 border-b border-[#EDEDED] last:border-b-0"
          >
            <div>
              <p
                style={{
                  fontFamily: 'Manrope',
                  fontWeight: 500,
                  fontSize: '16px',
                  color: '#0B111E',
                }}
              >
                {option.title}
              </p>
              <p
                style={{
                  fontFamily: 'Manrope',
                  fontWeight: 400,
                  fontSize: '14px',
                  color: '#757575',
                  marginTop: '2px',
                }}
              >
                {option.description}
              </p>
            </div>
            <button
              onClick={() => handleToggle(option.id)}
              disabled={loading}
              className={`relative w-12 h-6 rounded-full transition-colors ${
                settings[option.id] ? 'bg-[#015FA6]' : 'bg-gray-300'
              } ${loading ? 'opacity-50' : ''}`}
            >
              <span
                className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform ${
                  settings[option.id] ? 'translate-x-7' : 'translate-x-1'
                }`}
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyNotificationCard;
